import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { SimpleLoadingComponent, loadMorePaginationProp } from '../../utils/apollo';
import RepVisitsNotificationsRequests from './notifications-requests';
import { getOrdinalDate } from '../RepVisitsSearchPage/date-utils';
import { virtualNotificationTypes } from '../../components/ActivityNotification/constants';

const actorFragment = gql`
  fragment ActorDetails on CommunityPerson {
    id
    name
    uuid
    field_profile_picture_file_url
    field_user_institution_title
    institutionId
    field_office_phone
    field_office_phone_privacy
    field_mobile_phone
    field_mobile_phone_privacy
    field_job_position
    field_contact_work
  }
`;

export const EventsAndNotifications = gql`
  query EventsAndNotifications(
    $first: Int!,
    $after: String,
    $notificationTypes: [RepVisitsNotificationType],
    $fromDate: OrdinalDate!,
    $toDate: OrdinalDate!,
    $userBookingStatus: RSVPStatus!
  ) {
    viewer {
      id
      uuid
      repVisitsEvents(fromDate: $fromDate, toDate: $toDate, userBookingStatus: $userBookingStatus) {
        id
        dayId
        appointmentId
        collegeFairId
        date
        dateRegistered
        startTime
        chosenVisitLocationType
        highSchool {
          name
          id
          address {
            field_hs_elna_city
            field_hs_elna_state_latest
          }
        }
      }
      repVisitsNotifications(first: $first, after: $after, notificationTypes: $notificationTypes) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            notificationType
            actor {
              ...ActorDetails
            }
            date
            event {
              id
              date
              name
              startTime
              endTime
              collegeFairId
              appointmentId
              chosenVisitLocationType
              visitUrl
              dayId
              visitCreator
            }
            rescheduleInfo {
              date
              startTime
              endTime
            }
            message
            highSchool {
              id
              title
              address {
                field_hs_elna_city
                field_hs_elna_state_latest
              }
            }
            reassignInfo {
              fromContact {
                ...ActorDetails
              }
              toContact {
                ...ActorDetails
              }
            }
          }
        }
      }
    }
  }
  ${actorFragment}
`;

const dismissNotificationMutation = gql`
  mutation dismissRepVisitsNotification($input: dismissRepVisitsNotificationInput!){
    dismissRepVisitsNotification(input: $input) {
      viewer {
        id
      }
    }
  }
`;

const dismissNotification = graphql(dismissNotificationMutation, {
  name: 'dismissNotification',
  options: {
    refetchQueries: ['NotificationCount'],
  },
});

const graphqlData = graphql(EventsAndNotifications, {
  options: () => {
    const dateObj = new Date();
    const fromDate = getOrdinalDate(dateObj);
    const nextYear = new Date();
    nextYear.setFullYear(nextYear.getFullYear() + 1);
    return {
      variables: {
        fromDate,
        toDate: getOrdinalDate(nextYear),
        userBookingStatus: 'PENDING',
        first: 25,
        notificationTypes: virtualNotificationTypes,
      },
      fetchPolicy: 'network-only',
    };
  },
  props: loadMorePaginationProp(EventsAndNotifications),
});

export default SimpleLoadingComponent(graphqlData, dismissNotification)(RepVisitsNotificationsRequests);
